<template>
  <LoaderContainer :loading="loading">
    <div class="row">
      <div class="col-lg-12">
        <div class="d-flex align-items-center mb-2">
          <small class="mr-3 mb-0 bold text-info info-container">i</small>
          <small class="text-muted mr-1 mb-0">
            Double Click to enter more entries
          </small>
        </div>
        <div
          class="header d-flex align-items-center w-100 justify-content-between"
        >
          <p class="header-title mb-0">Particulars</p>
          <p class="header-title mb-0">Amount</p>
        </div>
        <div
          class="w-100 table-body d-flex align-items-center justify-content-between"
        >
          <h5 class="mb-0 body-title">
            <b>Liabilities</b>
          </h5>
        </div>
        <ShareholderFunds />
        <NonCurrentLiabilities />
        <CurrentLiabilities />
        <Total />
      </div>
    </div>
  </LoaderContainer>
</template>

<script setup>
import { storeToRefs } from "pinia";
import { useNoneIFRSBalanceSheet } from "../../../../../../store/NonIFRS/balancesheet.store";
import { LoaderContainer } from "../../../../../common";
import ShareholderFunds from "./ShareholderFunds.vue";
import NonCurrentLiabilities from "./NonCurrentLiabilities.vue";
import CurrentLiabilities from "./CurrentLiabilities.vue";
import Total from "./Total.vue";
import { onMounted } from "vue";

defineProps({
  view: {
    type: Boolean,
    default: false,
  },
});
const nonIFRSBsStore = useNoneIFRSBalanceSheet();
const { loading } = storeToRefs(nonIFRSBsStore);

onMounted(() => {
  loading.value = true;
});
</script>

<style scoped>
.header {
  min-height: 44px;
  background: #0f75bc;
  padding-right: 100px;
  padding-left: 10px;
}

.header-title {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.055em;
  color: #fafbff;
}
.table-body {
  min-height: 44px;
  padding-right: 100px;
  padding-left: 26px;
}

.body-title {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 21px;
  letter-spacing: 0.055em;
  color: #382628;
}

.white {
  background: #fafbff;
}

.gray {
  background: #deeded;
}
.info-container {
  height: 30px;
  width: 30px;
  border-radius: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #deeded;
}
</style>
